__turbopack_context__.v({
  "actionLink": "Maskot-module__y49bxa__actionLink",
  "assistant": "Maskot-module__y49bxa__assistant",
  "avatar": "Maskot-module__y49bxa__avatar",
  "avatarLoading": "Maskot-module__y49bxa__avatarLoading",
  "avatarPulse": "Maskot-module__y49bxa__avatarPulse",
  "blink": "Maskot-module__y49bxa__blink",
  "closeBtn": "Maskot-module__y49bxa__closeBtn",
  "closeBubble": "Maskot-module__y49bxa__closeBubble",
  "cursor": "Maskot-module__y49bxa__cursor",
  "dotPulse": "Maskot-module__y49bxa__dotPulse",
  "emptyIcon": "Maskot-module__y49bxa__emptyIcon",
  "emptyState": "Maskot-module__y49bxa__emptyState",
  "header": "Maskot-module__y49bxa__header",
  "headerIcon": "Maskot-module__y49bxa__headerIcon",
  "headerLeft": "Maskot-module__y49bxa__headerLeft",
  "headerSub": "Maskot-module__y49bxa__headerSub",
  "headerTitle": "Maskot-module__y49bxa__headerTitle",
  "input": "Maskot-module__y49bxa__input",
  "inputRow": "Maskot-module__y49bxa__inputRow",
  "loadingDot": "Maskot-module__y49bxa__loadingDot",
  "messages": "Maskot-module__y49bxa__messages",
  "msg": "Maskot-module__y49bxa__msg",
  "notifBounce": "Maskot-module__y49bxa__notifBounce",
  "notifDot": "Maskot-module__y49bxa__notifDot",
  "popIn": "Maskot-module__y49bxa__popIn",
  "proactiveBubble": "Maskot-module__y49bxa__proactiveBubble",
  "quickBtns": "Maskot-module__y49bxa__quickBtns",
  "root": "Maskot-module__y49bxa__root",
  "sendBtn": "Maskot-module__y49bxa__sendBtn",
  "streaming": "Maskot-module__y49bxa__streaming",
  "user": "Maskot-module__y49bxa__user",
  "window": "Maskot-module__y49bxa__window",
});
